import { Link } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import { useWishlist } from '../shared/context/WishlistContext';
import { useAddToCart } from '../shared/hooks/useAddToCart';
import './WishlistPage.css';

export default function WishlistPage() {
  const { items, toggle } = useWishlist();
  const addToCart = useAddToCart();

  return (
    <div className="page-shell">
      <Navbar />
      <main className="wish">
        <div className="wish__shell">
          <aside className="wish__rail">
            <p className="wish__kicker">Saved</p>
            <h1>Wishlist</h1>
            <p className="wish__count">
              {items.length === 0
                ? 'Your favourites will live here.'
                : `${items.length} piece${items.length === 1 ? '' : 's'} waiting`}
            </p>
            <Link to="/products" className="wish__browse">
              Continue shopping →
            </Link>
            <ul className="wish__tips">
              <li>Move pieces to bag anytime</li>
              <li>Saved on this device</li>
              <li>Synced when you sign in</li>
            </ul>
          </aside>

          <div className="wish__main">
            {items.length === 0 ? (
              <div className="wish__empty">
                <div className="wish__empty-visual" aria-hidden />
                <h2>Nothing saved yet</h2>
                <p>Heart the pieces that feel like you — they’ll gather here.</p>
                <Link to="/products" className="wish__cta">
                  Discover pieces
                </Link>
              </div>
            ) : (
              <div className="wish__stripes">
                {items.map((p, i) => {
                  const product = typeof p === 'object' ? p : { _id: p };
                  const onSale =
                    product.actualPrice > product.sellingPrice && product.discount > 0;
                  const catName =
                    product.category?.name ||
                    (typeof product.category === 'string' ? product.category : '');
                  const sizes = product.sizesAvailable || [];
                  const color = product.color || product.colors?.[0] || product.colour;
                  return (
                    <article
                      key={product._id}
                      className={`wish-stripe${i % 2 === 1 ? ' wish-stripe--alt' : ''}`}
                    >
                      <Link
                        to={`/products/${product._id}`}
                        className="wish-stripe__media"
                        style={{
                          backgroundImage: product.images?.[0]
                            ? `url(${product.images[0]})`
                            : undefined,
                        }}
                        aria-label={product.title || 'Saved piece'}
                      >
                        <span className="wish-stripe__heart" aria-hidden>
                          ♥
                        </span>
                      </Link>

                      <div className="wish-stripe__body">
                        <div className="wish-stripe__row wish-stripe__row--top">
                          <div className="wish-stripe__identity">
                            {catName && <span className="wish-stripe__cat">{catName}</span>}
                            <Link to={`/products/${product._id}`}>
                              <h2>{product.title || 'Saved piece'}</h2>
                            </Link>
                            <div className="wish-stripe__subline">
                              {product.productCode && <span>Art. {product.productCode}</span>}
                              {product.subtitle && <span>{product.subtitle}</span>}
                            </div>
                          </div>
                          <div className="wish-stripe__price">
                            {onSale && (
                              <span className="wish-stripe__off">−{product.discount}%</span>
                            )}
                            {product.sellingPrice != null && (
                              <strong>₹{Number(product.sellingPrice).toLocaleString()}</strong>
                            )}
                            {onSale && (
                              <s>₹{Number(product.actualPrice).toLocaleString()}</s>
                            )}
                          </div>
                        </div>

                        <div className="wish-stripe__row wish-stripe__row--meta">
                          <ul className="wish-stripe__facts">
                            {product.fabricType && (
                              <li>
                                <span>Fabric</span>
                                <em>{product.fabricType}</em>
                              </li>
                            )}
                            {product.embroidery && (
                              <li>
                                <span>Detail</span>
                                <em>{product.embroidery}</em>
                              </li>
                            )}
                            {color && (
                              <li>
                                <span>Colour</span>
                                <em className="wish-stripe__color">
                                  <i style={{ background: color }} aria-hidden />
                                  {typeof color === 'string' && color.startsWith('#')
                                    ? 'Custom'
                                    : color}
                                </em>
                              </li>
                            )}
                          </ul>
                          {sizes.length > 0 && (
                            <div className="wish-stripe__sizes" aria-label="Available sizes">
                              {sizes.slice(0, 8).map((s) => (
                                <span key={s}>{s}</span>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="wish-stripe__row wish-stripe__row--actions">
                          {product.title && (
                            <button
                              type="button"
                              className="wish-stripe__cart"
                              onClick={() =>
                                addToCart(product, product.sizesAvailable?.[0] || '')
                              }
                            >
                              Add to bag
                            </button>
                          )}
                          <button
                            type="button"
                            className="wish-stripe__remove"
                            onClick={() => toggle(product)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
